import { render, staticRenderFns } from "./latest_signed_up.vue?vue&type=template&id=a3aa572e&scoped=true&"
import script from "./latest_signed_up.vue?vue&type=script&lang=js&"
export * from "./latest_signed_up.vue?vue&type=script&lang=js&"
import style0 from "./latest_signed_up.vue?vue&type=style&index=0&id=a3aa572e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3aa572e",
  null
  
)

export default component.exports